import { render } from "./Legal.vue?vue&type=template&id=30180fd6&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"

import "./Legal.vue?vue&type=style&index=0&id=30180fd6&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30180fd6"]])

export default __exports__